import React from 'react';
import PropTypes from 'prop-types';
import { currency as getFormat } from 'Helpers/Formats';
import Format from '..';

import './index.css';

const Currency = ({ className, amount }) => (
  <Format className={`Currency ${className}`.trim()}>
    {getFormat(amount, true)}
  </Format>
);

Currency.propTypes = {
  className: PropTypes.string,
  amount: PropTypes.number,
};
Currency.defaultProps = {
  className: '',
  amount: 0,
};

export default Currency;
